import { createRoute } from "@tanstack/react-router";
import { Route as rootRoute } from "../__root";
import { DashboardLayout } from "@/frontend/components/dashboard/DashboardLayout";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: "dashboard",
  component: DashboardLayout,
});
